/* ***************************************************************** */
/*                                                                   */
/* Licensed Materials - Property of Merative                         */
/*                                                                   */
/* (C) Copyright Merative Corp. 2025                                 */
/*                                                                   */
/* ***************************************************************** */

export const NEOPED_URL = "/neoped";
export const RESULT_TYPE_PEDIATRICS = "pediatrics";
export const RESULT_TYPE_PEDIATRICS_UPPER_CASE = RESULT_TYPE_PEDIATRICS.charAt(0).toUpperCase() + RESULT_TYPE_PEDIATRICS.slice(1);
export const RESULT_TYPE_NEOFAX = "neofax";
export const NEONATAL = "Neonatal";
export const SECTION_TYPE_DRUGS = "drugs";
export const SECTION_TYPE_FORMULAS = "formulas";
export const NO_NEOPEDS_SUBSCRIPTIONS_MESSAGE = "You do not have subscriptions to either NeoFax or Pediatrics. Please contact your system administrator to obtain a subscription.";
export const NEOFAX_PEDIATRICS_ERROR_TYPE = "neofax_pediatrics_error";
export const NEOFAX_PICKLIST_ID = "neofax_picklist";
export const PEDIATRICS_PICKLIST_ID = "pediatrics_picklist";
export const NEOFAX_PAGE_NAME = "neofax_search_page";
export const DRUG_MONOGRAPHS_TAB_NAME = "Drug Monographs";
export const ENTERAL_FORMULA_TAB_NAME = "Enteral Formulas";
// Enteral Formula Search page
export const NEOFAX_FORMULA_PICKLIST_ID = "neofax_formula_picklist";
export const PEDIATRICS_FORMULA_PICKLIST_ID = "pediatrics_formula_picklist";
export const FORMULA_SEARCH_PANEL_NAME = "formula_search_panel";
export const FORMULA_NUTRITION_DETAILS_ROUTE = "/enteral/nutrientDetails";
export const FORMULA_PRODUCT_NOTES_ROUTE = "/enteral/productnotes";
export const PER_100_CAL = "per100Cal";
export const PER_LITER = "perLiter";
export const PER_BOTH = "both";

export const NEO_PED_MONOGRAPH_DEFAULT_SECTION = "viewFullDocument";

export const NEO_PED_DRUG_ID_KEY =  "neoPedDrugId";
export const NO_PAGE_VIEW_TRACKING = "noPageViewTracking";
